const Arios = () => (
    <>
          <p className="other-bio">
               An A-rank bracer of the Bracer Guild's Crossbell branch.
          </p>
          <p className="oter-bio">
               Also known as the Divine Blade of Wind, he is regarded as a hero by the citizens for his outstanding swordsmanship and problem-solving skills. 
          </p>
          <p className="other-bio">
               He and Lloyd join forces in Trails to Azure.
          </p>
     </>
)

const Dudley = () => (
     <>
          <p className="other-bio">
               A senior detective of the renowned First Division of the Crossbell Police Department.
          </p>
          <p className="other-bio">
               Although he did not acknowledge Lloyd and the SSS at first, he ultimately wound up cooperating with them.
          </p>
          <p className="other-bio">
               In light of his past performance, he plays a greater role in Trails to Azure.
          </p>
     </>
)

const Rixia = () => (
     <>
          <p className="other-bio">
               An up-and-coming performer who made her glorious stage debut in Trails from Zero.
          </p>
          <p className="other-bio">
               Her true identity is that of Yin, a skilled xiongshou--or assassin--who is feared throughout the Republic's Eastern Quarter.
          </p>
          <p className="other-bio">
               In Trails to Azure, this double life of hers is inadvertently brought to light...
          </p>
     </>
)

const Ilya = () => (
     <>
          <p className="other-bio">
          The stunning leading star of the Arc en Ciel theater troupe.
          </p>
          <p className="other-bio">
          Also known as the Fervent Dancer, she has many devoted fans across the continent.
          </p>
          <p className="other-bio">
          Upon discovering Rixia's talent, she forcefully convinces her to join the troupe.
          </p>
          <p className="other-bio">
          At present, Ilya is hard at work preparing for their newest production.
          </p>
     </>
)

const Sully = () => (
     <>
          <p className="other-bio">
               A child from the slums who drifted to Crossbell.
          </p>
          <p className="other-bio">
               Envious of the illustrious Ilya, she attempts to rob her, but is eventually forgiven and taken on as an assistant and trainee of the troupe.
          </p>
          <p className="other-bio">
               Sully is often mistaken as a boy, but ends up playing an unexpected role in Trails to Azure.
          </p>
     </>
)

const Shirley = () => (
     <>
          <p className="other-bio">
          The only daughter of Sigmund Orlando, and a commanding officer of the Red Constellation.
          </p>
          <p className="other-bio">
          Despite her small frame, she wields a gigantic chainsaw-rifle hybrid and is feared by many as "Bloody Shirley."
          </p>
          <p className="other-bio">
          Shirley is actually quite innocent in her own way and has no ill intentions. She does, however, love to fight.
          </p>
     </>
)
const Sigmund = () => (
     <>
          <p className="other-bio">
          Randy's uncle and the vice leader of the Red Constellation.
          </p>
          <p className="other-bio">
          Also known as the Scarlet Ogre, he is feared as a warrior of indomitable strength who razes battlefields with his giant twin battle axes.
          </p>
          <p className="other-bio">
          Sigmund, his daughter Shirley, and the Red Constellation arrive in Crossbell for "business." Though what that entails is yet a mystery...
          </p>
     </>
)
const Zeit = () => (
     <>
          <p className="other-bio">
          A large, white wolf who resembles the legendary Divine Wolf of Crossbellan myth.
          </p>
          <p className="other-bio">
          He first appeared before Lloyd and the crew during the War Hound incident, and has since resided in the SSS building as their "police dog."
          </p>
     </>
)
const Sergei = () => (
     <>
          <p className="other-bio">
          The chief and founder of the Special Support Section.
          </p>
          <p className="other-bio">
          He was formerly a skilled detective himself, but was treated as a nuisance by his superiors.
          </p>
          <p className="other-bio">
          Sergei has a laissez-faire sort of attitude, but supports Lloyd and the team when it matters most.
          </p>
     </>
)
const Sonya = () => (
     <>
          <p className="other-bio">
          A calm, collected, and intelligent ranking officer who assisted Lloyd and the SSS in Trails from Zero.
          </p>
          <p className="other-bio">
          After the resignation of her disreputable predecessor, she took his place as commander of the Crossbell Guardian Force.
          </p>
          <p className="other-bio">
          Sonya strives to reform the CGF while also preparing for the potential threat of the two major powers bordering Crossbell.
          </p>
     </>
)
const Mireille = () => (
     <>
          <p className="other-bio">
          A CGF guardswoman at Bellguard Gate and former colleague of Randy's.
          </p>
          <p className="other-bio">
          Bright and hardworking, Mireille kept her unit together despite the incompetence of their former commander.
          </p>
          <p className="other-bio">
          She has negative feelings about Randy's departure from the CGF.
          </p>
     </>
)
const Olivert = () => (
     <>
          <p className="other-bio">
               The prince of Erebonia and an infamously uninhibited free spirit.
          </p>
          <p className="other-bio">
          He is one of the main characters in the Trails in the Sky games.
          </p>
          <p className="other-bio">
          In Trails to Azure, Olivert visits Crossbell for reasons both known and unknown...
          </p>
     </>
)
const Mueller = () => (
     <>
          <p className="other-bio">
          A major in the Imperial Army, Mueller is a peerless warrior who serves as Prince Olivert's bodyguard, having come from a military family who has traditionally protected the Erebonian royal family for generations.
          </p>
          <p className="other-bio">
          Since childhood, he has been both a friend and an elder brother of sorts to Olivert, and often finds himself cleaning up after the latter's many escapades.
          </p>
     </>
)
const Giliath = () => (
     <>
          <p className="other-bio">
          The representative of the Imperial government, also known as the "Blood and Iron Chancellor."
          </p>
          <p className="other-bio">
          Since his appointment ten years ago, he has worked to reform the Erebonian aristocracy and construct a railroad network across the Empire.
          </p>
          <p className="other-bio">
          His efforts have earned him many enemies, such as the noble classes and resistance organizations from the Empire's annexed territories.
          </p>
     </>
)
const Lechter = () => (
     <>
          <p className="other-bio">
          An eccentric young man who Lloyd and the team met at the Schwarze Auction in Trails from Zero.
          </p>
          <p className="other-bio">
          Apparently, he works for the Blood and Iron Chancellor. Aside from that, he is a man of mystery who wears a variety of hats, from second secretary of the Imperial government to a captain of the Imperial Army.
          </p>
          <p className="other-bio">
          Lechter visits Crossbell again in Trails to Azure, working toward some unspecified purpose.
          </p>
     </>
)
const Campanella = () => (
     <>
          <p className="other-bio">
          Enforcer No. 0 of the Society of Ouroboros.
          </p>
          <p className="other-bio">
          Known as "The Fool," Campanella is a mischievous provocateur.
          </p>
          <p className="other-bio">
          His actions since appearing in Crossbell are enigmatic at best...
          </p>
     </>
)
const Arianrhod = () => (
     <>
          <p className="other-bio">
          The Seventh Anguis of the Society of Ouroboros.
          </p>
          <p className="other-bio">
          A master combatant, she is known to be honorable and righteous, but is also unrelenting to any who oppose her.
          </p>
     </>
)
const F = () => (
     <>
          <p className="other-bio">
               The Sixth Anguis of Ouroboros and the leader of the Thirteen Factories.
          </p>
          <p className="other-bio">
               He has developed a variety of machines, from giant Archaisms to airships beyond imagination, and is willing to make any sacrifice to satisfy his intellectual curiosity.
          </p>
     </>
)
const Wald = () => (
     <>
          <p className="other-bio">
          The leader of the Saber Vipers, a gang of delinquents that pride themselves as street brawlers.
          </p>
          <p className="other-bio">
          His ferocity and might have rallied many members under his command.
          </p>
          <p className="other-bio">
          In Trails from Zero, he worked with Lloyd and the team to stop the mafia, but has since become deeply resentful of his rival, Wazy, joining the police force.
          </p>
     </>
)
const Abbas = () => (
     <>
          <p className="other-bio">
          The second-in-command of the Testaments, a gang of delinquents that pride themselves as intellectuals.
          </p>
          <p className="other-bio">
          He seems to greatly revere their leader, Wazy, and accepts his choice to join the police.
          </p>
          <p className="other-bio">
          Abbas keeps the gang's members in line while also running a billiards bar in the Downtown District.
          </p>
          <p className="other-bio">
          While extremely quiet and not very friendly, he is surprisingly sensible.
          </p>
     </>
)
const Mariabell = () => (
     <>
          <p className="other-bio">
               A powerful, confident young woman and only daughter of Dieter Crois.
          </p>
          <p className="other-bio">
          Since her father became mayor, she has been occupied with running the business side of the IBC in his stead.
          </p>
          <p className="other-bio">
          She is a childhood friend of Elie's and has a clear distaste for Lloyd's familiarity with her.
          </p>
     </>
)
const Dieter = () => (
     <>
          <p className="other-bio">
               The CEO of the IBC (International Bank of Crossbell).
          </p>
          <p className="other-bio">
               After the cult incident, he made a surprise campaign for mayor, winning the election.
          </p>
          <p className="other-bio">
               Since taking office, he has busy managing a skyscraper construction project and organizing a large-scale international conference in the city, all while lending his support to the SSS.
          </p>
     </>
)
const Klaudia = () => (
     <>
          <p className="other-bio">
               The Crown Princess of the Liberl Kingdom.
          </p>
          <p className="other-bio">
               She has come to Crossbell aboard the Arseille to attend an international conference in place of her grandmother, Queen Alicia II.
          </p>
          <p className="other-bio">
               Accompanying her is her companion, a gyrfalcon named Sieg.
          </p>
     </>
)
const Julia = () => (
     <>
          <p className="other-bio">
          A senior captain of the Royal Army of Liberl. She is also the head of the Royal Guard and captain of the Arseille.
          </p>
          <p className="other-bio">
          After coming to Crossbell as Princess Klaudia's bodyguard, she becomes acquainted with Lloyd and the SSS.
          </p>
          <p className="other-bio">
          She has many female fans across the continent due to her gallant and elegant demeanor.
          </p>
     </>
)
const Kilika = () => (
     <>
          <p className="other-bio">
          The head of the Republic's intelligence division: The Rocksmith Agency.
          </p>
          <p className="other-bio">
          She meets the SSS in Trails from Zero and helps them resolve the incident in Crossbell, though seemingly for her own separate purpose. In Trails to Azure, she reappears as the aide of President Rocksmith.
          </p>
          <p className="other-bio">
          Kilika was formerly a receptionist at the Zeiss branch of the Liberlian Bracer Guild. She is also a master of Taito, an Eastern martial art.
          </p>
     </>
)
const Samuel = () => (
     <>
          <p className="other-bio">
          The President of the Republic of Calvard, known for his populist appeal.
          </p>
          <p className="other-bio">
          Though he appears to be a kindly middle-aged man at first glance, he is cunning enough to keep the clashes between Calvard's Eastern immigrants and Republican nationalists in check, while also strategically maneuvering their relations with Erebonia and Crossbell.
          </p>
     </>
)
const Cecile = () => (
     <>
          <p className="other-bio">
          A nurse at St. Ursula Medical College.
          </p>
          <p className="other-bio">
          She has known Lloyd since childhood, acting as an older sister figure to him when he lived in an apartment on West Street. Lloyd's older brother, Guy, was engaged to her before his untimely death.
          </p>
          <p className="other-bio">
          In Trails to Azure, she ends up accompanying Lloyd and the SSS to a special event.
          </p>
     </>
)
const Shizuku = () => (
     <>
          <p className="other-bio">
          The only daughter of bracer Arios MacLaine.
          </p>
          <p className="other-bio">
          After a tragic accident in Crossbell claimed her sight, she was hospitalized at St. Ursula for long-term treatment.
          </p>
          <p className="other-bio">
          A kind girl who always cares for others, she and KeA became the best of friends in Trails from Zero.
          </p>
          <p className="other-bio">
          In Trails to Azure, she is slated to undergo a major operation under a newly appointed doctor.
          </p>
     </>
)
const Guy = () => (
     <>
          <p className="other-bio">
          Lloyd's older brother, a strong and tenacious detective who died in the line of duty three years ago.
          </p>
          <p className="other-bio">
          Guy lost his life while uncovering the dark truths behind the mafia, the cult, and the major powers' covert activities in Crossbell.
          </p>
          <p className="other-bio">
          In Trails to Azure, the truth behind his unsolved death may just come to light.
          </p>
     </>
)
const Kevin = () => (
     <>
          <p className="other-bio">
          The protagonist of The Legend of Heroes: Trails in the Sky the 3rd and a traveling priest of the Septian Church.
          </p>
          <p className="other-bio">
          Despite his cheerful and upbeat personality, he is actually the fifth of the twelve Dominions of the Gralsritter, a covert unit of the church.
          </p>
          <p className="other-bio">
          In Trails to Azure, he becomes acquainted with Lloyd after coming to his aid during a certain incident.
          </p>
     </>
)
const Ries = () => (
     <>
          <p className="other-bio">
          A sister of the Septian Church and squire of the Gralsritter.
          </p>
          <p className="other-bio">
          She grew up with Kevin and was the heroine of The Legend of Heroes: Trails in the Sky the 3rd.
          </p>
          <p className="other-bio">
          In Trails to Azure, she begins working at Crossbell Cathedral, clad in a new habit. 
          </p>
     </>
)

const OtherBio = [
     <Arios/>, <Dudley/>, <Rixia/>, <Ilya/>, <Sully/>, <Shirley/>, <Sigmund/>, <Zeit/>, <Sergei/>, <Sonya/>, <Mireille/>, <Olivert/>, <Mueller/>, <Giliath/>, <Lechter/>, <Campanella/>, <Arianrhod/>, <F/>, <Wald/>, <Abbas/>, <Mariabell/>, <Dieter/>, <Klaudia/>, <Julia/>, <Kilika/>, <Samuel/>, <Cecile/>, <Shizuku/>, <Guy/>, <Kevin/>, <Ries/>
]

const OtherData = [
     {
          name: "Arios MacLaine",
          image: "arios"
     },
     {
          name: "Alex Dudley",
          image: "dudley",
          classes: "increase"
     },
     {
          name: "Rixia Mao",
          image: "rixia",
          classes: "decrease"
     },
     {
          name: "Ilya Platiere",
          image: "ilya",
          classes: "decrease"
     },
     {
          name: "Sully Atraid",
          image: "sully",
          classes: "right"
     },
     {
          name: "Shirley Orlando",
          image: "shirley",
          classes: "right"
     },
     {
          name: "Sigmund Orlando",
          image: "sigmund"
     },
     {
          name: "Zeit",
          image: "zeit",
          classes: "bottom"
     },
     {
          name: "Sergei Lou",
          image: "sergei",
          classes: "left"
     },
     {
          name: "Sonya Baelz",
          image: "sonya",
          classes: "bottom"
     },
     {
          name: "Mireille",
          image: "mireille",
          classes: "right bottom"
     },
     {
          name: "Olivert Reise Arnor",
          image: "olivert"
     },
     {
          name: "Mueller Vander",
          image: "mueller"
     },
     {
          name: "Giliath Osborne",
          image: "giliath"
     },
     {
          name: "Lechter Arundel",
          image: "lechter",
          classes: "top decrease"
     },
     {
          name: "Campanella",
          image: "campanella",
          classes: "right"
     },
     {
          name: "Arianrhod",
          image: "arianrhod",
          classes: "bottom"
     },
     {
          name: "F. Novartis",
          image: "f"
     },
     {
          name: "Wald Wales",
          image: "wald",
          classes: "increase"
     },
     {
          name: "Abbas",
          image: "abbas"
     },
     {
          name: "Mariabell Crois",
          image: "mariabell",
          classes: "right"
     },
     {
          name: "Dieter Crois",
          image: "dieter",
          classes: "top"
     },
     {
          name: "Klaudia von Auslese",
          image: "klaudia",
          classes: "right"
     },
     {
          name: "Julia Schwarz",
          image: "julia"
     },
     {
          name: "Kilika Rouran",
          image: "kilika",
          classes: "right"
     },
     {
          name: "Samuel Rocksmith",
          image: "samuel"
     },
     {
          name: "Cecile Neues",
          image: "cecile"
     },
     {
          name: "Shizuku MacLaine",
          image: "shizuku",
          classes: "decrease right"
     },
     {
          name: "Guy Bannings",
          image: "guy"
     },
     {
          name: "Kevin Graham",
          image: "kevin",
          classes: "right"
     },
     {
          name: "Ries Argent",
          image: "ries",
          classes: "right"
     }
]


export { OtherBio, OtherData};